import { inject, Injectable, OnDestroy } from '@angular/core';
import { EventService, FeatureConfigService, GlobalMessageService, LoginEvent } from '@spartacus/core';
import { Observable, EMPTY } from 'rxjs';
import { UserAccountEventListener } from '@spartacus/user/account/root';
import { switchMap } from 'rxjs/operators';
import { BaseService } from '../../../../shared/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class CustomUserAccountEventListener extends UserAccountEventListener implements OnDestroy {
  private featureConfigService = inject(FeatureConfigService);

  constructor(
    protected eventService: EventService,
    protected globalMessageService: GlobalMessageService,
    protected baseService: BaseService
  ) {
    super(eventService, globalMessageService);
    if (this.featureConfigService.isEnabled('authorizationCodeFlowByDefault')) {
      this.onLogin();
    }
  }

  protected onLogin(): void {
    this.subscriptions.add(
      this.eventService.get(LoginEvent)
        .pipe(
          switchMap(() => {
            if (localStorage.getItem('punchout-sid-key') == null) {
              return this.loginNotification();
            }
            return EMPTY;
          })
        )
        .subscribe()
    );
  }

  private loginNotification(): Observable<any> {
    return this.baseService.post('/users/current/loginnotification', {});
  }
}
